export enum UserNameNormalization {
    upperCase = 0,
    lowerCase = 1,
    unchanged = 2
}
export namespace UserNameNormalization{
    export function getName(value: UserNameNormalization): string {
        switch (value) {
            case UserNameNormalization.upperCase:
                return "upperCase";
            case UserNameNormalization.lowerCase:
                return "lowerCase";
            case UserNameNormalization.unchanged:
                return "unchanged";
            default:
                return "???";
        }
    }
}
